<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <BreadCrumbs v-model="user_info.deviceGroupId" @click_breadCrumbs="selectedGroupChange" />
        <v-divider />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          v-model="table.selected"
          class="v-data-table-outlined"
          :headers="table.headers"
          :items="table.items"
          :loading="table.loading"
          fixed-header
          disable-pagination
          hide-default-footer
          show-select
          item-key="id"
        >
          <template v-slot:top>
            <v-toolbar flat dense>
              <v-spacer></v-spacer>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="openDialog('delete')"
                    color="red"
                    :disabled="table.selected.length === 0"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('delete') }}</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDialog('add')" color="blue" icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('regist') }}</span>
              </v-tooltip>
            </v-toolbar>
          </template>
          <template v-slot:item.edit="{ item }">
            <v-icon @click="openDialog('edit', item)" color="green"> mdi-circle-edit-outline </v-icon>
          </template>
          <template v-slot:no-data>
            {{ $t('noDataFound') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- 登録ダイアログ -->
    <v-dialog @click:outside="openDialog('add')" v-model="dialog.add.show" max-width="500">
      <v-card>
        <v-card-title>
          {{ $t('groupRegistration') }}
        </v-card-title>
        <v-form v-model="dialog.add.valid" @submit.prevent="addGroup()" ref="addForm">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-alert :value="dialog.add.error.show" type="error">
                  {{ dialog.add.error.text }}
                </v-alert>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="dialog.add.inputData.groupName"
                  :label="$t('groupName')"
                  :rules="
                    countValid({
                      num: 20,
                      msg1: $t('requiredField'),
                      msg2: $t('pleaseEnterWithinCharacters', { num: 20 }),
                    })
                  "
                  outlined
                  clearable
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog.add.show = false" color="secondary" text>
              {{ $t('cancel') }}
            </v-btn>
            <v-btn :disabled="!dialog.add.valid" type="submit" color="primary" text>
              {{ $t('regist') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- 編集ダイアログ -->
    <v-dialog v-model="dialog.edit.show" max-width="500">
      <v-card>
        <v-card-title>
          {{ $t('groupEditing') }}
        </v-card-title>
        <v-form v-model="dialog.edit.valid" @submit.prevent="editGroup()" ref="editForm">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-alert :value="dialog.edit.error.show" type="error">
                  {{ dialog.edit.error.text }}
                </v-alert>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="dialog.edit.inputData.groupName"
                  :label="$t('groupName')"
                  :rules="
                    countValid({
                      num: 20,
                      msg1: $t('requiredField'),
                      msg2: $t('pleaseEnterWithinCharacters', { num: 20 }),
                    })
                  "
                  outlined
                  clearable
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog.edit.show = false" color="secondary" text>
              {{ $t('cancel') }}
            </v-btn>
            <v-btn :disabled="!dialog.edit.valid" type="submit" color="primary" text>
              {{ $t('update') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- 削除ダイアログ -->
    <v-dialog v-model="dialog.delete.show" max-width="500">
      <v-card>
        <v-card-title>
          {{ $t('groupDeletion') }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-alert :value="dialog.delete.error.show" type="error">
                {{ dialog.delete.error.text }}
              </v-alert>
            </v-col>
            <v-col cols="12">
              <v-alert type="warning">
                {{ $t('areYouSureYouWantToDeleteTheFollowingGroups') }}
              </v-alert>
            </v-col>
            <v-col cols="12">
              <ul>
                <li v-for="item in table.selected" :key="item.id">
                  {{ item.groupName }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.delete.show = false" color="secondary" text>
            {{ $t('cancel') }}
          </v-btn>
          <v-btn @click="deleteGroups" color="primary" text>
            {{ $t('delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import BreadCrumbs from '@/components/BreadCrumbs.vue';
  import { mapGetters } from 'vuex';
  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'GroupingSetting',
    components: {
      BreadCrumbs,
    },
    data: () => ({
      table: {
        headers: [],
        items: [],
        selected: [],
        loading: true,
      },
      dialog: {
        add: {
          show: false,
          valid: true,
          error: {
            show: false,
            text: '',
          },
          inputData: {},
        },
        edit: {
          show: false,
          valid: true,
          error: {
            show: false,
            text: '',
          },
          inputData: {},
        },
        delete: {
          show: false,
          error: {
            show: false,
            text: '',
          },
        },
      },
    }),
    computed: {
      ...mapGetters('auth', ['user_info']),
      countValid: () => (val) => [(v) => !!v || val.msg1, (v) => !v || v.length <= val.num || val.msg2],
    },
    async created() {
      this.table.headers = [
        {
          text: this.$t('groupName'),
          align: 'start',
          value: 'groupName',
          class: 'v-data-table-border-left',
          cellClass: 'v-data-table-border-left',
        },
        {
          text: this.$t('createdBy'),
          value: 'creatorId',
          class: 'v-data-table-border-left',
          cellClass: 'v-data-table-border-left',
        },
        {
          text: this.$t('dateOfCreation'),
          value: 'created',
          class: 'v-data-table-border-left',
          cellClass: 'v-data-table-border-left',
        },
        {
          text: this.$t('updatedBy'),
          value: 'updaterId',
          class: 'v-data-table-border-left',
          cellClass: 'v-data-table-border-left',
        },
        {
          text: this.$t('dateOfUpdate'),
          value: 'updated',
          class: 'v-data-table-border-left',
          cellClass: 'v-data-table-border-left',
        },
        {
          text: this.$t('edit'),
          value: 'edit',
          class: 'v-data-table-border-left',
          cellClass: 'v-data-table-border-left',
          sortable: false,
        },
      ];
      this.dialog.add.error.text = this.$t('anErrorOccurredDuringTheGroupAdditionProcess');
      this.dialog.edit.error.text = this.$t('anErrorOccurredDuringTheGroupUpdateProcess');
      this.dialog.delete.error.text = this.$t('anErrorOccurredDuringTheGroupDeletionProcess');
      this.table.items = await this.getGroups();
      this.table.loading = false;
    },
    methods: {
      async getGroups() {
        const param = {
          deviceGroupId: this.user_info.deviceGroupId,
        };
        const groups = await this.azureRequest('/api/getGroups', 'GET', param);
        return groups;
      },
      async addGroup() {
        this.$store.commit('loading/start_loading');
        const request = {
          groupName: this.dialog.add.inputData.groupName,
          deviceGroupId: this.user_info.deviceGroupId,
          devices: [],
          mailId: '',
          updaterId: this.user_info.userId,
          creatorId: this.user_info.userId,
        };
        const result = await this.azureRequest('/api/addGroups', 'POST', request);
        if (result) {
          this.table.items = await this.getGroups();
          this.dialog.add.show = false;
        } else {
          this.dialog.add.error.show = true;
        }
        this.$store.commit('loading/end_loading');
      },
      async editGroup() {
        this.$store.commit('loading/start_loading');
        const request = {
          id: this.dialog.edit.inputData.id,
          groupName: this.dialog.edit.inputData.groupName,
          deviceGroupId: this.user_info.deviceGroupId,
          devices: this.dialog.edit.inputData.devices,
          mailId: this.dialog.edit.inputData.mailId,
          updaterId: this.user_info.userId,
        };
        const result = await this.azureRequest(`/api/putGroups`, 'PUT', request);
        if (result) {
          this.table.items = await this.getGroups();
          this.dialog.edit.show = false;
        } else {
          this.dialog.edit.error.show = true;
        }
        this.$store.commit('loading/end_loading');
      },
      async deleteGroups() {
        this.$store.commit('loading/start_loading');
        for (const item of this.table.selected) {
          const result = await this.azureRequest(`/api/deleteGroups?id=${item.id}`, 'DELETE');
          if (!result) {
            this.dialog.delete.error.show = true;
            this.$store.commit('loading/end_loading');
            return;
          }
        }
        this.table.items = await this.getGroups();
        this.table.selected = [];
        this.$store.commit('loading/end_loading');
        this.dialog.delete.show = false;
      },
      // 各ダイアログを表示する
      openDialog(operation, item) {
        if (operation === 'add') {
          this.dialog.add.show = true;
          this.dialog.add.error.show = false;
          this.$nextTick(() => {
            this.$refs.addForm.reset();
          });
        } else if (operation === 'edit') {
          this.dialog.edit.inputData = JSON.parse(JSON.stringify(item));
          this.dialog.edit.error.show = false;
          this.dialog.edit.show = true;
        } else {
          this.dialog.delete.error.show = false;
          this.dialog.delete.show = true;
        }
      },
      // パンくずリストクリック
      selectedGroupChange(group) {
        this.$router.push({
          name: group.children.length > 0 ? 'HomeAdmin' : 'HomeConsumer',
          params: { device_group_id: group.device_group_id },
        });
      },
    },
  };
</script>
<style></style>
